var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneRoundOutlined = function SvgPhoneRoundOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.786 4.486c-.093-1.513-1.413-2.9-2.893-3.02a26 26 0 0 0-3.787 0c-1.48.127-2.8 1.507-2.893 3.027a69 69 0 0 0 0 7.04c.093 1.514 1.413 2.9 2.893 3.02q.942.072 1.894.073c.633 0 1.26-.026 1.893-.073 1.48-.127 2.8-1.507 2.893-3.027.12-2.333.12-4.7 0-7.04m-.933 6.994c-.06 1.04-1.033 2.06-2.04 2.146a25.4 25.4 0 0 1-3.633 0c-1.007-.086-1.974-1.106-2.04-2.146-.12-2.307-.12-4.64 0-6.94.06-1.04 1.033-2.067 2.033-2.147q.1.002.2-.007c0 .02-.013.034-.013.054 0 .26.206.466.466.466H9.1c.26 0 .466-.206.466-.466 0-.02-.006-.034-.013-.054.08 0 .167 0 .247.007 1.006.087 1.973 1.107 2.04 2.147.12 2.306.12 4.64 0 6.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.907 11.953h-1.88a.464.464 0 0 0-.466.467c0 .26.206.466.466.466h1.88c.26 0 .467-.206.467-.466a.464.464 0 0 0-.467-.467"
  })));
};
export default SvgPhoneRoundOutlined;